import React, { useState } from "react";
import {
  Table,
  Row,
  Col,
  Form,
  DatePicker,
  Input,
  Button,
  Typography,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { reportService } from "../../../services";
import { handlePDFDownload, handlePrint, exportToExcel } from "../../../utils/printing";

const { Title } = Typography;
function LoadPlan() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadPlan, setLoadPlan] = useState([]);
  const [allloadPlan, setAllLoadPlan] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [payload, setPayload] = useState(null);

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
    },
    {
      title: "Container ID ",
      dataIndex: "Container Id",
      key: "Container Id",
    },
    {
      title: "Container Number",
      dataIndex: "Container Number",
      key: "Container Number",
    },
    {
      title: "Location",
      dataIndex: "Location",
      key: "Location",
    },

    {
      title: "Pullout Date",
      dataIndex: "Pullout Date",
      key: "Pullout Date",
    },
    {
      title: "GateIn Date",
      dataIndex: "GateIn Date",
      key: "GateIn Date",
    },
  ];
  const onFinish = (values) => {
    setPayload({
      from_date: values.from_date.format("YYYY-MM-DD"),
      to_date: values.to_date.format("YYYY-MM-DD"),
    });
    const payload = {
      from_date: values.from_date.format("YYYY-MM-DD"),
      to_date: values.to_date.format("YYYY-MM-DD"),
    };
    initialize(pagination.current, pagination.pageSize, payload);
  };

  const initialize = async (
    page = 1,
    pageSize = pagination.pageSize,
    payload = null
  ) => {
    setLoading(true);
    const { success, data } = await reportService.LoadPlan(page, payload);
    setLoading(false);
    if (success) {
      setLoadPlan(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.pagination.total,
        current: page,
        pageSize,
      }));
      getAllLoadPlan();
    }
    setLoading(false);
  };


  const getAllLoadPlan = async () => {
    const { data } = await reportService.LoadPlan(1, payload, true);
    console.log(data)
    setAllLoadPlan(data.data);
  }


  return (
    <>
      <Title level={5}>Load Plan</Title>
      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Row gutter={24} className="mt-8">
          <Col span={8}>
            <Form.Item label="From date" name="from_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="To date" name="to_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item label={<></>}>
              <Button type="primary" htmlType="submit">
                <SearchOutlined style={{ fontSize: "15px" }} />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Col span={24}>
        <Row
          gutter={0}
          style={{
            padding: "8px",
            marginTop: "2px",
            background: "#F2F2F7",
            borderRadius: "4px",
          }}
          className="flex justify-between"
        >
          <Col span={12}>
            <div className="flex">
              <Button onClick={() => handlePrint(allloadPlan, columns, "Load Plan Report")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }} >
                <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <FaRegFile style={{ fontSize: "20px" }} />
              </Button> */}

              <Button onClick={() => exportToExcel(allloadPlan, "Load_Plan_report.xlsx")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
              </Button>

              <Button onClick={() => handlePDFDownload(allloadPlan, columns, "Load Plan Report", false)} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <RiFileCopyLine style={{ fontSize: "24px" }} />
              </Button> */}
            </div>
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              className="w-auto lg:w-2/5"
            />
          </Col>
        </Row>
        <div id="printable-table">
          <Table
            columns={columns}
            scroll={{ x: "max-content" }}
            pagination={{
              current: pagination.current,
              total: pagination.total,
              pageSize: pagination.pageSize,
              onChange: (page) => initialize(page, pagination.pageSize, payload),
              showSizeChanger: false,
            }}
            loading={loading}
            dataSource={loadPlan}
            style={{ marginTop: "10px" }}
          />
        </div>
      </Col>
    </>
  );
}

export default LoadPlan;
